<template>
  <div class="grid row">
    <div class="flex xs12">
      <va-card title="Activity Page" class="fill-height">
        <div>
          <div class="row">
            <div class="flex xs12">
              <va-tabs v-model="tabValue" style="width: 100%; min-width: 250px; margin-bottom: 25px;">
                <va-tab
                  v-for="title in tabTitles"
                  :key="title"
                >
                  {{title}}
                </va-tab>
              </va-tabs>
              <div class="flex xs12" v-if="tabValue === 0">
                <va-input
                  label="Title *"
                  v-model="title"
                  :error="!!errors.product_title"
                  :error-messages="errors.product_title"
                  @input="delete errors.product_title"
                />
                <va-card class="mb-3" title="Image">
                  <div v-if="imageExisting">
                    <a style="display: block;" target="_blank" :href="imageExisting"><img style="max-width: 400px;" :src="imageExisting"></a>
                    <div><va-button small color="danger" @click="imageExisting = deleteImage(imageId, 'product_image') ? '' : imageExisting">Видалити</va-button></div>
                  </div>
                  <span>Завантажити нове зображення</span>
                  <va-file-upload
                    type="gallery"
                    dropzone
                    @input="delete errors.product_image"
                    v-model="image"
                    style="margin-bottom: 25px;"
                  />
                  <va-button @click="uploadImage('product_image', 'product_image', image[0])">Завантажити</va-button>
                  <div v-if="errors.product_image" style="color: red;">{{ errors.product_image[0] }}</div>
                </va-card>
                <va-input
                  label="Achievements Title"
                  v-model="achievementsTitle"
                  :error="!!errors.product_achievements_title"
                  :error-messages="errors.product_achievements_title"
                  @input="delete errors.product_achievements_title"
                />
                <va-toggle small label="Show achievements" v-model="showAchievements"></va-toggle>
                <va-toggle small label="Show testimonials" v-model="showTestimonials"></va-toggle>
                <va-input
                  label="SEO Title"
                  v-model="seoTitle"
                  :error="!!errors.product_seo_title"
                  :error-messages="errors.product_seo_title"
                  @input="delete errors.product_seo_title"
                />
                <va-input
                  label="SEO Description"
                  type="textarea"
                  v-model="seoDescription"
                  :error="!!errors.product_seo_description"
                  :error-messages="errors.product_seo_description"
                  @input="delete errors.product_seo_description"
                />
                <va-input
                  label="SEO OpenGraph Title"
                  v-model="seoOpenGraphTitle"
                  :error="!!errors.product_seo_ogtitle"
                  :error-messages="errors.product_seo_ogtitle"
                  @input="delete errors.product_seo_ogtitle"
                />
                <va-input
                  type="textarea"
                  label="SEO OpenGraph Description"
                  v-model="seoOpenGraphDescription"
                  :error="!!errors.product_seo_ogdescription"
                  :error-messages="errors.product_seo_ogdescription"
                  @input="delete errors.product_seo_ogdescription"
                />
                <va-card class="mb-3" title="SEO OpenGraph Image">
                  <div v-if="seoOpenGraphImageExisting">
                    <a style="display: block;" target="_blank" :href="seoOpenGraphImageExisting"><img style="max-width: 400px;" :src="seoOpenGraphImageExisting"></a>
                    <div><va-button small color="danger" @click="seoOpenGraphImageExisting = deleteImage(seoOpenGraphImageId, 'product_seo_ogimage') ? '' : seoOpenGraphImageExisting">Видалити</va-button></div>
                  </div>
                  <span>Завантажити нове зображення</span>
                  <va-file-upload
                    type="gallery"
                    dropzone
                    @input="delete errors.product_seo_ogimage"
                    v-model="seoOpenGraphImage"
                    style="margin-bottom: 25px;"
                  />
                  <va-button @click="uploadImage('product_seo_ogimage', 'product_seo_ogimage', seoOpenGraphImage[0])">Завантажити</va-button>
                  <div v-if="errors.product_seo_ogimage" style="color: red;">{{ errors.product_seo_ogimage[0] }}</div>
                </va-card>
                <va-button
                  @click="validate()"
                >Save</va-button>
              </div>
            </div>
          </div>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import * as axios from 'axios'
import Vue from 'vue'

export default {
  name: 'grid',
  data () {
    return {
      title: '',
      image: [],
      imageId: '',
      imageExisting: '',
      achievementsTitle: '',
      showAchievements: false,
      showTestimonials: false,

      seoTitle: '',
      seoDescription: '',
      seoOpenGraphTitle: '',
      seoOpenGraphDescription: '',
      seoOpenGraphImage: [],
      seoOpenGraphImageId: '',
      seoOpenGraphImageExisting: '',

      errors: [],

      tabTitles: ['Main'],
      tabValue: 0,
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    computedStyle () {
      return {
        backgroundColor: this.$themes.primary,
      }
    },
    locale () {
      return Vue.i18n.locale()
    },
    putData () {
      return {
        product_title: this.title,
        product_achievements_title: this.achievementsTitle,

        product_achievements_show: this.showAchievements ? 1 : 0,
        product_testimonials_show: this.showTestimonials ? 1 : 0,

        product_seo_title: this.seoTitle,
        product_seo_description: this.seoDescription,
        product_seo_ogtitle: this.seoOpenGraphTitle,
        product_seo_ogdescription: this.seoOpenGraphDescription,
      }
    },
  },
  watch: {
    locale: function (value) {
      this.fetch()
    },
  },
  methods: {
    uploadImage (param, key, file, agg = 'product') {
      if (!file) {
        return
      }
      const formData = new FormData()
      formData.append(param, file)
      formData.append('lang', this.locale)
      formData.append('aggregate', agg)
      formData.append('key', key)
      formData.append('multiple', '0')
      formData.append('file_id', '0')
      axios.post(`${process.env.VUE_APP_AGRO_API_URL}/admin/pages/upload/13?lang=${this.locale}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(response => {
          this.showToast('Successful upload')
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
    async deleteImage (id, fieldKey) {
      return axios.post(`${process.env.VUE_APP_AGRO_API_URL}/admin/pages/13/delete-file/${id}?lang=${this.locale}`, {
        key: fieldKey,
      })
        .then(() => {
          this.showToast('Successfully deleted')
        })
        .catch(() => {
          this.showToast('Error')
        })
    },
    submit () {
      axios.put(`${process.env.VUE_APP_AGRO_API_URL}/admin/pages/13?lang=${this.locale}`, this.putData)
        .then(response => {
          this.showToast('Successful update')
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 422) {
            this.errors = error.response.data.errors
          }
          this.showToast('Error')
        })
    },
    validate () {
      axios.put(`${process.env.VUE_APP_AGRO_API_URL}/admin/pages/validate/13?lang=${this.locale}`, this.putData, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(response => {
          this.errors = response.data
          if (!Object.keys(this.errors).length) {
            this.submit()
          }
        })
        .catch(error => {
          console.log(error)
          this.showToast('Validate Fetch Error')
        })
    },
    fetch () {
      axios.get(`${process.env.VUE_APP_AGRO_API_URL}/admin/pages/13?lang=${this.locale}`)
        .then(response => {
          this.title = response.data.product_title
          this.imageExisting = response.data.product_image ? process.env.VUE_APP_AGRO_ADMIN + response.data.product_image : null
          this.imageId = response.data.product_image_id
          this.achievementsTitle = response.data.product_achievements_title

          this.showAchievements = response.data.product_achievements_show === '1'
          this.showTestimonials = response.data.product_testimonials_show === '1'

          this.seoTitle = response.data.product_seo_title
          this.seoDescription = response.data.product_seo_description
          this.seoOpenGraphTitle = response.data.product_seo_ogtitle
          this.seoOpenGraphDescription = response.data.product_seo_ogdescription
          this.seoOpenGraphImageExisting = response.data.product_seo_ogimage ? process.env.VUE_APP_AGRO_ADMIN + response.data.product_seo_ogimage : null
          this.seoOpenGraphImageId = response.data.product_seo_ogimage_id
        })
        .catch(error => {
          console.log(error.response)
        })
    },
  },
}
</script>

<style lang="scss">
.grid {
  &__container {
    min-height: 3rem;
    color: $white;
    border-radius: 0.5rem;
  }
}

.va-file-upload-gallery-item {
  flex-basis: unset;
  max-width: 400px;
  width: unset;
}
</style>
